import { useModalBehavior } from "@/hooks/behaviors";
import { useState } from "react";

export function useSourcingFollowBehavior() {
  const { open: modalOpen, closeModal, openModal } = useModalBehavior();
  const [currentSourcingMaterialId, setCurrentSourcingMaterialId] = useState<
    string | null
  >(null);

  const handleViewSourcingProgress = (sourcingMaterialId: string) => {
    setCurrentSourcingMaterialId(sourcingMaterialId);
    openModal();
  };

  const handleCloseSourcingFollowModal = () => {
    closeModal();
    setCurrentSourcingMaterialId(null);
  };

  return {
    sourcingFollowModalOpen: modalOpen,
    currentSourcingMaterialId,
    handleViewSourcingProgress,
    handleCloseSourcingFollowModal,
  };
}
